export default {
  MASONRY_GRID: 'MASONRY_GRID',
  SET_ADS: 'SET_ADS',
  UPDATE_AD: 'UPDATE_AD',
};



// WEBPACK FOOTER //
// ./src/store/ads/ads.mutationlist.js